import React, { ErrorInfo } from 'react';
import loadable from '@loadable/component';
import { FormattedMessage } from 'react-intl';

const DatePicker = loadable(() =>
  import(
    /* webpackChunkName: "date-picker" */ 'react-date-picker/dist/entry.nostyle'
  ),
);

type Props = {
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  onChange: (date: Date | Date[]) => void;
  day?: Date;
};

export class DayPicker extends React.Component<Props> {
  componentDidCatch(error: Error, info: ErrorInfo) {
    console.log(error, info);
    if (window.Rollbar) window.Rollbar.critical(error, { source: 'daypicker' });
  }

  render() {
    const { day, onChange, onSubmit } = this.props;
    return (
      <div className="search-filters-radio__sub-content">
        <form className="search-filters-day" onSubmit={onSubmit}>
          <DatePicker
            calendarIcon={null}
            clearIcon={null}
            onChange={onChange}
            value={day}
          />
          <button className="search-filters-day__button" type="submit">
            <FormattedMessage id="search/components/aside-filters/dates/DayPicker.tsx/1" />
          </button>
        </form>
      </div>
    );
  }
}
